import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";

import { Card, Col, Row, Form, Button } from "@themesberg/react-bootstrap";

import AdminLayout from "../../layout/admin";
import { Header } from "../../components/admin";
import {
  hideLoadingDialog,
  showSuccessDialog,
  showFailedDialog,
  showLoadingDialog,
} from "../../helpers/dialog.helper";
import BASE_URL from "../../api";
import {
  generateSemesterList,
  generateStudyYearsList,
} from "../../helpers/helper";
import { useDispatch, useSelector } from "react-redux";
import {
  GetConfigSemester,
  reset,
} from "./../../features/config/ConfigSemesterSlice";

const ConfigSemesterPage = () => {
  const [dataSemester, setDataSemester] = useState([]);

  const dispatch = useDispatch();
  const { data, isLoading, isError } = useSelector(
    (state) => state.configSemester
  );

  const token = localStorage.getItem("token");

  useEffect(() => {
    dispatch(reset());
    dispatch(GetConfigSemester(token));
  }, [token, dispatch]);

  // update the field
  useEffect(() => {
    if ((data?.data || []).length > 0) {
      setDataSemester({
        period: data?.data[0].period,
        type: data?.data[0].type,
      });
    }
  }, [data]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    showLoadingDialog();
    try {
      const response = await axios.post(
        `${BASE_URL}config/semester`,
        {
          id: 1,
          ...dataSemester,
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      hideLoadingDialog();
      showSuccessDialog({
        title: "Berhasil!",
        msg: response?.data?.message || "Berhasil mengubah semester!",
      });
    } catch (error) {
      console.log("ERROR", error);
      hideLoadingDialog();
      showFailedDialog({
        title: "Oops!",
        msg: error?.response?.data?.message || "Something went wrong!",
      });
    }
  };

  return (
    <AdminLayout>
      <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-xl-0">
          <Header title="Konfigurasi Semester" />
        </div>
      </div>
      <Card border="light" className="shadow-sm mb-4">
        <Card.Body>
          {isLoading ? (
            <p>Loading...</p>
          ) : isError ? (
            <p>Oops!, something went wrong!</p>
          ) : (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={12} className="mb-3">
                  <Form.Group id="jenis_pembiayaan">
                    <Form.Label>Periode</Form.Label>
                    <Select
                      options={generateStudyYearsList()}
                      placeholder="Pilih semester"
                      value={generateStudyYearsList()?.find(
                        (e) => e.value === dataSemester.period
                      )}
                      required
                      onChange={(e) => {
                        setDataSemester({
                          ...dataSemester,
                          period: e.value,
                        });
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={12} className="mb-3">
                  <Form.Group id="isVerified">
                    <Form.Label>Jenis Semester</Form.Label>
                    <Select
                      options={generateSemesterList()}
                      placeholder="Pilih semester"
                      value={generateSemesterList()?.find(
                        (e) => e.value === dataSemester.type
                      )}
                      required
                      onChange={(e) => {
                        setDataSemester({
                          ...dataSemester,
                          type: e.value,
                        });
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Button type="submit">Update</Button>
                </Col>
              </Row>
            </Form>
          )}
        </Card.Body>
      </Card>
    </AdminLayout>
  );
};

export default ConfigSemesterPage;
